export enum ESortOrder {
  ASCENDING = 1,
  DESCENDING = -1,
}